import {SearchItem, SearchResultDto} from "./search-table.dto.res";
import {InvoiceDto} from "../document/invoice.dto";
import {DocumentContactType} from "../../../libs/enum/document-contact-type";
import {DocumentContactDto} from "../document-contact.dto";
import {DocumentPaymentDto} from "../document-payment.dto";

export class SearchInvoiceRes extends SearchResultDto {

  public override readonly items: SearchInvoiceItem[] = [];

  constructor(init?: Partial<SearchInvoiceRes>) {
    super(init);
    if (init?.items) {
      this.items = init.items.map((i) => new SearchInvoiceItem(i));
    } else {
      this.items = [];
    }
  }
}

export class SearchInvoiceItem extends InvoiceDto implements SearchItem {

  public deliveryNoteMediaId: string | undefined;
  // Document-Contact
  public dcId!: string;
  public dcType!: DocumentContactType;
  public dcContactId!: string;
  public dcContactType: string | undefined;
  public dcContactFullName: string | undefined;
  public dcContactNumber: string | undefined;
  public dcContactManualInput: string | undefined;
  public dcContactVehicleId: string | undefined;
  public dcContactVehicleName: string | undefined;
  // Payment
  public readonly paymentId!: string;
  public readonly paymentCompleted!: boolean;
  public readonly paymentBalance!: number;
  // Funeral/Death
  public readonly deathDeceasedId: string | undefined;
  public readonly deathFullName: string | undefined;

  constructor(init?: Partial<SearchInvoiceItem>) {
    super(init);
    Object.assign(this, init);
    this.contact = new DocumentContactDto({
      id: this.dcId,
      type: this.dcType,
      contactId: this.dcContactId,
      contactType: this.dcContactType,
      number: this.dcContactNumber,
      manualInput: this.dcContactManualInput,
      fullName: this.dcContactFullName,
      // Vehicle
      vehicleId: this.dcContactVehicleId,
      vehicleName: this.dcContactVehicleName,
    });
    this.payment = new DocumentPaymentDto({
      id: this.paymentId,
      completed: this.paymentCompleted,
      balance: this.paymentBalance,
    });
  }
}
